import { GzExchangeContentControlAttachmentFilteringRulesFormWebComponent } from './component/GzExchangeContentControlAttachmentFilteringRulesFormWebComponent';

export { GzExchangeContentControlAttachmentFilteringRulesFormWebComponent };
